var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-page-frame"},[_c('c-edit',{attrs:{"eid":"page--gallery-index"}}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.stransition,"mode":"out-in"}},[_c(_vm.component,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }